import PropTypes from 'prop-types'
import React, { Component } from 'react'

import colors from 'styles/colors.json'
import { InlineEditor } from 'components/shared/InlineEditor'
import makeCmdEnterHandler from 'components/customer/Inputs/makeCmdEnterHandler'
import isInputValid from 'components/customer/Inputs/isMediumInputEmpty'
import Cancel from './Cancel'

const ThickGrayBorder = `2px solid ${colors['color-navy-light']}`

const NoteDisplay = [
  <img
    style={{ width: 13, height: 13.5, marginRight: 6 }}
    src={require('images/svg/note.svg')}
  />,
  "New Note"
]

class NoteInput extends Component {
  static contextTypes = {
    app: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = {}
  }

  handleInputChange = (input) => {
    this.setState({ input })
  }

  onCancel = () => {
    this.setState({ input: null })
  }

  canSubmit() {
    return isInputValid(this.state.input)
  }

  createNote = () => {
    if (!this.canSubmit()) return
    this.context.app.queries.NoteQueries.createNoteForEndUserId(this.props.endUser.id, { body: this.state.input })
    this.setState({ input: null })
  }

  onEditorKeyDown = makeCmdEnterHandler(this.createNote)

  render() {
    const canPost = this.canSubmit()
    return (
      <div style={{
        borderRadius: "0 0 5px 5px",
        border: ThickGrayBorder,
        backgroundColor: "white",
      }}>
        <InlineEditor
          options={{
            placeholder: { text: 'start typing to leave a note...' },
            noImageDragging: true
          }}
          onChange={this.handleInputChange}
          onKeyDown={this.onEditorKeyDown}
          style={{
            padding: 13,
            minHeight: 90
          }}
          text={this.state.input}
        />
        <div
          style={{
            borderTop: ThickGrayBorder,
            padding: '5px 12px',
          }}
          className="flex-end"
        >
          { canPost ? <Cancel onClick={this.onCancel}/> : null }
          <div
            style={{
              fontSize: 14,
              fontWeight: 600,
              transition: "color .3s",
              cursor: canPost ? 'pointer' : 'not-allowed',
              color: canPost ? colors['color-blue'] : colors['color-navy'],
              textTransform: 'uppercase'
            }}
            onClick={this.createNote}
          >
            Post
          </div>
        </div>
      </div>
    )
  }
}

export const Option = {
  display: NoteDisplay,
  component: NoteInput
}

export default NoteInput



// WEBPACK FOOTER //
// ./src/scripts/components/customer/Inputs/NoteInput/index.js